module.exports = __webpack_public_path__ + "static/media/ftl-dry-van.2cafbed4.svg";